import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthOpenIdService } from '../_Services/auth/auth-open-id-service';
import { ExaScanUser } from '../_Services/apih/exa-scan-user';
import { ScanSyncService } from '../Services/scan-sync-service';

export const apihGuard: CanActivateFn = async (route, state) => {
  const authService = inject(AuthOpenIdService);
  const router = inject(Router);
  const userService = inject(ExaScanUser);
  const syncService = inject(ScanSyncService);

  // Wacht tot het token uit storage geladen is (belangrijk bij page refresh)
  await authService.waitUntilReady();

  const ensureUserAndSync = () => {
    // Fire-and-forget: niet awaiten zodat de guard niet blokkeert op WhoAmI.
    // De interceptor handelt 401 af (token refresh) zonder in een loop te geraken.
    if (!userService.currentUser()) {
      userService.loadCurrentUser().subscribe({ error: () => {} });
    }
    syncService.triggerSync();
  };

  if (authService.isLoggedIn()) {
    ensureUserAndSync();
    return true;
  }

  // Probeer token te refreshen
  const refreshed = await authService.refreshToken();
  if (refreshed) {
    ensureUserAndSync();
    return true;
  }

  router.navigate(['/auth/login']);
  return false;
};
